{
	"dropzoneTitle": "Arrastra y suelta el archivo aquí",
	"dropzoneSubtitle": "o haz clic para seleccionar el archivo",
	"fileDetails": "Tipo de archivo: {{fileType}} hasta {{fileSize}}",
	"downloadSample": "Descargar tabla de ejemplo",
	"downloadInvalidSheet": "Descargar tabla con errores",
	"errorImporting": "No se pudo importar la tabla",
	"errorInvalidHeader": "Las columnas de la hoja no coinciden con la plantilla esperada. Descarga una nueva plantilla e inténtalo de nuevo.",
	"errorUnreadableFile": "No se pudo leer el archivo. Verifica que sea un archivo .xlsx válido y no esté dañado.",
	"errorEmptySheet": "La hoja está vacía.",
	"errorEmptyHeaderCell": "Hay una columna sin título en el encabezado. Usa la plantilla predeterminada y no dejes columnas sin nombre.",
	"selectFile": "Seleccionar un archivo",
	"selectAnotherFile": "Seleccionar otro archivo",
	"invalidFileTitle": "El archivo seleccionado no es válido",
	"invalidFileReasonInvalidType": "Tipo de archivo no permitido. Usa archivos {{formats}}.",
	"invalidFileReasonTooLarge": "El archivo excede el tamaño máximo de {{maxSize}}.",
	"invalidFileReasonTooManyFiles": "Solo se puede cargar {{maxFiles}} archivo a la vez.",
	"invalidFileReasonTooSmall": "El archivo es más pequeño de lo permitido.",
	"invalidFileReasonDefault": "No se puede importar el archivo. Verifica los requisitos e inténtalo de nuevo.",
	"confirmCloseDialog": {
		"title": "Salir de la importación en masa",
		"description": "¿Estás seguro de querer salir de la importación en masa sin descargar la hoja de errores?",
		"descriptionStrong": "No podrás descargarla nuevamente y perderás esta información.",
		"cancel": "Salir de la edición",
		"download": "Descargar hoja de errores"
	},
	"importNewFile": "Importar nuevo archivo"
}
